import { useState,useEffect,useRef } from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/global/modal";
import ModalHeader from "components/global/modal-header";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";
import Input from 'components/input/input';
import ToolTipVid from "components/get-started/components/tooltip-vid";
import { currentLang,urlSerializer } from "utils/utils";
import toast from "react-hot-toast";
import CreatableSelect from "components/select/creatable";
import AutoCompleteAddress from "components/google-address/auto-complete";
import { quick_CREATE_MILESTONE } from "utils/constant";
import PopInfo from "components/info-popup/pop-info";
import InputGroup from "components/input-group/input-group";
import _ from "lodash";
import update from "immutability-helper";
import { groupTypes } from "utils/constant";

export default function AddQuickMilestone({
  hide,
  userData,
  profile,
  ...props
}){
    const { http } = global.services;
    const {t} = useTranslation();
    const [submitLoading, setSubmitLoading] = useState(false);
    const [state, setState] = useState({
        year:null,
        title:'',
        position:null,
        category:null,
        platform:"",
        location:""
    });
    const [errorMessages,seterrorMessages] = useState({})
    const [positionOptions, setPositionOptions] = useState([]);
    const [categoriesOptions, setCategoriesOptions] = useState([]);
    const [jobs, setJobs] = useState([{ job_role: "", description: "" }]);
    const [btnAddPositionHidden, setBtnAddPositionHidden] = useState(false);
    const [showMedia, setShowMedia] = useState(false);
    const [url, setUrl] = useState(null);
    
    let dontShowTut = useRef(false);
    useEffect(()=>{
        getPositions();
        getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    const createPosition = async (e) => {
        try {
        let { data } = await http.post("/public/positions", {
            user_id: profile.user.id,
            user_profile_id: profile.id,
            position: e.label,
        });
        getPositions();
        return data.data;
        } catch (err) {
        console.log(err);
        }
    };

    const createCategory = async (val) => {
        try {
        let { data } = await http.post("/public/categories", {
            user_id: profile.user.id,
            user_profile_id: profile.id,
            category: val.label,
        });
        getCategories();
        return data.data;
        } catch (err) {
        console.log(err);
        }
    };

    const handleInputChange = async (e) => {
        const { name, value } = e.target;


        if (name === "category" && value?.__isNew__) {
            const data = await createCategory(value);
            setState((prev) => ({
                ...prev,
                [name]: { label: data.name, value: data.id }
            }));
            return;
        }else if(name === "position" && value?.__isNew__){ 
            const data = await createPosition(value);
            setState((prev) => ({
                ...prev,
                [name]: { label: data.name, value: data.id }
            }));
            return;
        }

        if(name === "year" && value.length > 4) {
            return e.preventDefault();
        }

        setState((prev) => ({
        ...prev,
        [name]: value,
        validationErrors: { ...state.validationErrors, [name]: null },
        }));
        seterrorMessages((prev)=>(
            {
                ...prev,
                [name]:null
            }
        ))
    };

    const setMinYear = (e) =>{ 
        const { name, value } = e.target;
        if(e.target?.min && parseInt(e.target?.min) > parseInt(value)){
            setState((prev) => ({
                ...prev,
                [name]: e.target.min
            }));
            return;
        }
    }

    const getPositions = async () => {
      try {
        const lang = currentLang();
        const url = urlSerializer("public/positions", {
          user_profile_id: profile.id,
        });
  
        const { data } = await http.get(url);
        const positions = data.map((position) => ({
          label: lang ? (position[lang] || position.name) : position.name,
          value: position.id,
        }));
        setPositionOptions(positions);
      } catch (err) {
        console.log("error@getPositions", err);
        throw err;
      }
    };
  
    const getCategories = async () => {
      try { 
        const lang = currentLang();
        const url = urlSerializer("public/categories", {
          user_profile_id: profile.id,
        });
        const { data } = await http.get(url); 
        const categories = data.map((c) => ({
          // label: !profile.dateFormat ? (c.english_version || c.name) : c.name,
          value: c.id,
          label: lang ? (c[lang] || c.name) : !profile.dateFormat ? (c.english_version || c.name) : c.name
        }));
        setCategoriesOptions(categories);
      } catch (err) {
        console.log("error@getCategories", err);
        throw err;
      }
    };

    const hideTutorial = async(dontShowAgain=false) =>{
        if(dontShowAgain){
        try {
        dontShowTut.current = dontShowAgain;
        await http.put(`public/profiles/tutorialMilestone/${profile.id}`,{
            column:'milestone_create'
        });
        } catch (err) {
        console.log(err);
        }
        }
    }

    const submit = async()=>{
        try {
            let isValid = true;
            let newErrors = {}
            setSubmitLoading(true);
            const { title, year, category } = state || {};
            const isComplete = title && year && jobs && category
            
            if (!isComplete) {
                isValid = false;
                if (!title) newErrors.title = "Title is required";
                if (!year) newErrors.year = "Year is required";
                if (!jobs || jobs.length === 0)
                        newErrors.position = "Position is required";
                if (!category || category.length === 0)
                        newErrors.category = "Category is required";
                
            }

            if(!isValid){
                seterrorMessages(newErrors)
                setSubmitLoading(false);
                return;
            } 
            let categoryIds = [];
            if(Array.isArray(category) && category?.length > 0) {
                state.category.forEach((category, index) => {
                    categoryIds.push(category.value);
                });
            }
            let positions = [];
            jobs.filter(p => p.job_role != null && p.job_role !== "").forEach((p, index) => {
                if (typeof p.job_role === "object") {
                    const { value } = p.job_role;
                    positions = [...positions, {job_role:value, description:p.description}];
                } else {
                    positions = [...positions, {job_role:p.job_role, description:p.description}];
                }
            });

            const payload = {
                ...state,
                category:categoryIds,
                position:positions,
                user_id: profile.user_id
            }
            const { data } = await http.post("public/milestones/qiuck-create", payload);
            hide({ data, success: true, dontShowTut:dontShowTut.current });
        } catch (err) {
            console.log("error@submit", err);
            const { data, status } = err;
            if (status === 422) {
                seterrorMessages(data.errors)
            }
            toast.error(
                status === 422 ? data?.message : t('somethingWentWrong')
            );
            setSubmitLoading(false);
        } finally {
            setSubmitLoading(false);
        }
    }

    const handleAddressChange = (fieldName, addressValue) => {
        setState((prev) => ({
        ...prev,
        [fieldName]: addressValue,
        validationErrors: { ...prev.validationErrors, [fieldName]: null },
        }));
    };

    const onChangeInput = (e, index) => {
        let payload = _.clone(jobs);
        let result = update(payload, {
        [index]: {
            description: { $set: e.target.value },
        },
        }); //remove
        setJobs(result);
    };

     const onSelectJobRole = async (e, index) => {
        let _remove = jobs[index] ? jobs[index].job_role : {};
        let _value = e ? e.value : "";
        let opt = e ? e : "";

        if (!_value) {
        _remove = jobs[index].job_role;
        }

        if (e && e.__isNew__) {
        let createdPosition = await createPosition(e);
        opt = { label: createdPosition.name, value: createdPosition.id };
        _value = createdPosition.id;

        setSelectJobRole(_remove, _value, opt, index);
        } else {
        setSelectJobRole(_remove, _value, opt, index);
        }
    };
    const setSelectJobRole = (_remove, _value, opt, index) => {
        let types = positionOptions.map((op) => {
          if (op.value === _value) {
            return {
              ...op,
              selected: true,
            };
          } else if (op.value === _remove.value) {
            const { selected, ...val } = op;
            return val;
          }
          return op;
        });
        setPositionOptions((prev) => types);
    
        let payload = _.clone(jobs);
        let result = update(payload, {
          [index]: {
            job_role: { $set: opt },
          },
        }); //remove
        setJobs(result);
      };

    const onRemoveJobRole = (index) => {
        if (jobs.length === 1) return;
    
        let types = positionOptions.map((op) => {
          if (op.value === jobs[index].job_role.value) {
            const { selected, ...val } = op;
            return val;
          }
          return op;
        });
        setPositionOptions((prev) => types);
    
        let payload = _.clone(jobs);
        let result = update(payload, { $splice: [[index, 1]] }); //remove
        setJobs(result);
    
        if (result.length < 5) setBtnAddPositionHidden(false);
        else setBtnAddPositionHidden(true);
      };

    const onAddPosition = () => {
        if (jobs.length === 5) return;
    
        let payload = _.clone(jobs);
        payload.push({ job_role: "", description: "" });
        setJobs(payload);
    
        if (jobs.length < 4) setBtnAddPositionHidden(false);
        else setBtnAddPositionHidden(true);
    };

    const showMediaHandle = (url=null)=>{
        setShowMedia(true);
        setUrl(url);
    }

    return (
        <Modal
            width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-9/20 1xl:w-8/20"
            contentClassName="rounded-lg overflow-auto custom-scroll"
            wrapperClassName="overflow-visible" 
        >
            <div className="w-full relative">
                {/**Video Insruction */}
                <ToolTipVid 
                    show={profile?.onboarding && Boolean(profile?.onboarding?.milestone_create) === false}  
                    title={t('quickCreateMilestone')}
                    onClick={hideTutorial}
                    desc={()=> {
                    return (
                        <>
                            <p>{t('quickCreateDesc')}</p>
                        </>
                        )
                     }
                    }
                    video={quick_CREATE_MILESTONE}
                    />
                <ModalHeader
                    title={t('quickCreateMilestone')}
                    hide={hide}
                    showPopInfo
                    popInfoType="add_milestone_quick"
                    padding="pl-3 pr-7 py-3.5"
                    // showMediaHandle = {showMediaHandle}
                    />
                <div className="px-4 py-2">
                    <Input
                        inputContainerClass="form-input-container mb-2"
                        value={state.title}
                        name="title"
                        outsideLabel={t("title")}
                        placeholder={t("starWars")}
                        outsideLabelClass="text-sm font-bold text-darkerGray marked w-full flex flex-row gap-x-2 items-center"
                        noLabelPaddingY="0.8rem"
                        type="text"
                        onChange={(e)=>{handleInputChange(e)}}
                        errorMessagePosition="bottom"
                        errorMessage={errorMessages?.title}
                        showPopInfo={true}
                        popInfoType="title"
                        />
                    <div className="flex flex-wrap w-full gap-4">
                        <div className="w-full">
                            {/* <CreatableSelect
                                label={t('position')}
                                options={positionOptions}
                                placeholder={t('pleaseSelect')}
                                name="position"
                                height={58}
                                value={
                                    state?.position?.value &&
                                    positionOptions.filter((g) => g.value === state?.position?.value)
                                }
                                onChange={(e) =>
                                handleInputChange({
                                    target: { name: "position", value: e },
                                })
                                }
                                errorMessage={errorMessages?.position}
                                labelClass="text-sm font-bold text-darkerGray leading-4 marked flex flex-row gap-x-2 items-center"
                                formContainer="mb-0"
                                showPopInfo={true}
                                popInfoType="positions"
                            /> */}
                            {
                                !groupTypes.includes(profile?.profile_type?.type) && 
                                <InputGroup
                                    title={t('position')}
                                    subTitleLeft={t('jobRole')}
                                    subTitleRight={t('informationJob')}
                                    options={positionOptions}
                                    items={jobs}
                                    fieldKey="job_role"
                                    onChange={(e, index) => onChangeInput(e, index)}
                                    onSelect={(e, index) => onSelectJobRole(e, index)}
                                    onRemove={(index) => onRemoveJobRole(index)}
                                    onAdd={onAddPosition}
                                    hideAddButton={btnAddPositionHidden}
                                    errors={errorMessages}
                                    customClass="marked"
                                    showPopInfo={true}
                                    popInfoType="positions"
                                    showMediaHandle = {showMediaHandle}
                                />
                            }
                        </div>  
                        <div className="w-full">
                            <CreatableSelect
                                isMulti
                                label={t('Category')}
                                options={categoriesOptions}
                                placeholder={t('pleaseSelect')}
                                name="category"
                                height={58}
                                value={
                                    state?.category?.value &&
                                    categoriesOptions.filter((g) => g.value === state?.category?.value)
                                }
                                onChange={(e) =>
                                handleInputChange({
                                    target: { name: "category", value: e },
                                })
                                }
                                errorMessage={errorMessages?.category}
                                labelClass="text-sm font-bold text-darkerGray leading-4 marked flex flex-row gap-x-2 items-center"
                                formContainer="mb-0"
                                showPopInfo={true}
                                popInfoType="category"
                            />
                        </div>
                        <div className="w-full mb-2">
                            <Input
                                min="1900"
                                max={`${2099}`}
                                value={state?.year}
                                name='year'
                                placeholder={t('year')}
                                outsideLabel={t("year")}
                                inputClass="border border-borderGray rounded-md"
                                outsideLabelClass="text-sm font-bold text-darkerGray marked w-full flex flex-row gap-x-2 items-center"
                                noLabelPaddingY="1rem"
                                type="number"
                                onChange={(e)=>{handleInputChange(e)}}
                                errorMessagePosition="bottom"
                                disableUpDownArrow={true}
                                onWheel={(e)=>e.target.blur()}
                                onBlur={setMinYear}
                                maxLength={4}
                                errorMessage={errorMessages?.year}
                                showPopInfo={true}
                                popInfoType="start_end_year"
                            />  
                        </div>
                    </div>
                    <div className="full">
                        <Input
                        inputContainerClass="form-input-container mb-2"
                        value={state?.platform}
                        name="platform"
                        outsideLabel={t('platform')}
                        otherLabel={t('companyVenueNetwork')}
                        placeholder={t('centuryFox')}
                        optional={true}
                        outsideLabelClass="text-sm font-bold text-darkerGray w-full flex flex-row gap-x-2 items-center"
                        noLabelPaddingY="1rem"
                        type="text"
                        onChange={handleInputChange}
                        errorMessage={errorMessages?.platform}
                        showPopInfo={true}
                        popInfoType="platform"
                        />
                    </div>
                    <div className="w-full">
                        <label for="location" className="text-sm font-bold text-darkerGray leading-4 flex flex-row gap-x-2 items-center pb-2">
                            {t('location')}
                            <span className="font-normal"> ({t('optional')})</span>
                            <span className="font-normal leading-4">{t('cityTownState')}</span>
                            <div className="text-black font-normal">
                                <PopInfo type={'location'} borderColor="border-darkerGray" verticalDirection="top" topCss="-8.5rem"/>
                            </div>
                        </label>
                        <AutoCompleteAddress
                            name="location"
                            value={state?.location || ""}
                            onChange={handleAddressChange}
                            placeholder="Hobart, Tas, AUS"
                            errorMessage={state.validationErrors?.location}
                            formContainer="mb-1"
                            /> 
                    </div>
                </div>
                <div className="border-t border-gray py-4 px-4">
                    <div className="w-full flex items-center justify-end 1sm:justify-end space-x-2">
                        <Button
                            buttonName={t('cancel')}
                            buttonClass="bg-thBg py-4 px-8 hover:bg-gray min-w-[7rem]"
                            buttonTextClass="text-black text-sm font-semibold"
                            onClick={() => hide({dontShowTut:dontShowTut.current})}
                            disabled={submitLoading}
                        />
                        <Button
                            key="save-btn-category"
                            buttonName={t('addMilestone')}
                            buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary min-w-[7rem]"
                            buttonTextClass="w-full text-white text-sm font-semibold flex items-center justify-center"
                            onClick={submit}
                            loadingIcon={
                            submitLoading ? (
                                <LoadingIndicator className="text-white w-4 h-4 ml-2" />
                            ) : null
                            }
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}